import { CERTIFICATE_STATUS, CertificateStatus, enumValueFromRaw } from '@features/certificate/models/certificate-select-options.model'

const CERTIFICATE_STATUS_COLOR: Record<CertificateStatus, string> = {
  [CERTIFICATE_STATUS.DRAFT]: 'bg-amber-500',
  [CERTIFICATE_STATUS.ACTIVE]: 'bg-lime-500',
  [CERTIFICATE_STATUS.SUPERSEDED]: 'bg-gray-500',
  [CERTIFICATE_STATUS.CANCELLED]: 'bg-red-500'
}

const UNKNOWN_STATUS_COLOR = 'bg-gray-500'

export function certificateStatusColor(rawStatus: string | null | undefined): string {
  const status = enumValueFromRaw(CERTIFICATE_STATUS, rawStatus)
  if (status === null) {
    return UNKNOWN_STATUS_COLOR
  }
  return CERTIFICATE_STATUS_COLOR[status] ?? UNKNOWN_STATUS_COLOR
}
